// extracted by mini-css-extract-plugin
export default {"addButton":"PortfoliosView_addButton__Nh18e","addCard":"PortfoliosView_addCard__EC7-V"};